export var DEFAULT_PORT = 33003;
export var LOCALHOST = 'http://127.0.0.1:';
export var MAX_PORT_SEARCH = 20;
export var MAX_POLLING_ERRORS = 3;
export var VERSION_PREFIX = '/v6';
export var SESSION_LASTKNOWN_ID = 'aspera-last-known-session-id';
export var SESSION_LASTKNOWN_KEY = 'aspera-last-known-session-key';
export var SESSION_LASTKNOWN_PORT = 'aspera-last-known-port';
